<template>
    <div class="visual">
        <div :class="['visual', 'is-' + background]">
            <Title :title="title" class="visual__title"></Title>
        </div>
    </div>
</template>

<script>
import Title from '@/components/common/Title'
export default {
    name: 'Visual',
    components: { Title },
    props: [ 'title', 'background' ]
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
.visual {
    position: relative;
    width: 100%;
    height: 450px;
    background: #ddd;
    background-repeat: no-repeat;
    background-size: cover;

    &.is-about {
        background-image: url(../../assets/image/background/background_about.jpg);
        background-position: 15% center;
    }
    &.is-business {
        background-image: url(../../assets/image/background/background_business.jpg);
        background-position: 20% center;
    }
    &.is-recruit {
        background-image: url(../../assets/image/background/background_recruit.jpg);
        background-position: 35% center;
    }
    &::before {
        @include gradient;
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.5;
    }
    &__title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
@include under-tablet {
    .visual {
        height: 66vw;
        &.is-about {
            background-image: url(../../assets/image/background/background_about_m.jpg);
            background-position: center;
        }
        &.is-business {
            background-image: url(../../assets/image/background/background_business_m.jpg);
            background-position: center;
        }
        &.is-recruit {
            background-image: url(../../assets/image/background/background_recruit_m.jpg);
            background-position: center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Visual.vue